import React from 'react';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

export const InputField = ({ input, placeholder, className, type, meta: { touched, error }, disabled, ...props }) => {
    return (
        <input
            disabled={disabled}
            placeholder={placeholder}
            className={className + (touched && error ? ' is-danger' : '')}
            {...input}
            type={type}
            {...props}
        />
    );
};

export const TextAreaField = ({ input, placeholder, className, rows, type, meta: { touched, error }, ...props }) => {
    return (
        <textarea
            placeholder={placeholder}
            className={className + (touched && error ? ' is-danger' : '')}
            {...input}
            type={type}
            rows={rows}
            {...props}
        ></textarea>
    );
};

export const InputFieldIcon = ({
    input,
    placeholder,
    inputFieldIcon,
    inputField,
    className,
    showPassword,
    setShowPassword,
    meta: { touched, error },
    disabled,
}) => {
    return (
        <div className={inputField}>
            <input
                disabled={disabled}
                placeholder={placeholder}
                className={className + (touched && error ? ' is-danger' : '')}
                {...input}
                type={showPassword ? 'text' : 'password'}
            />
            <i className={inputFieldIcon} onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
            </i>
        </div>
    );
};
